/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { toast } from 'react-hot-toast' // Npm: React hot toast.
import { useMutation } from '@apollo/client' // Npm: Apollo client.
import { connect } from 'react-redux' // Npm: React Redux for state management.


/*
 * SIBLINGS
 */
import DeleteCard from 'components/DeleteCard'


/*
 * GRAPHS
 */
import ContactBookDirectoryDeleteMutation from './__mutation__/index.contactBookDirectory.delete.mutation'


/*
 * OBJECTS
 */
const Index = ({ passOn, onClose }) => {
  // Hook assignment.
  const [MutationContactBookDirectoryDelete, MutationContactBookDirectoryDeleteResponse] = useMutation(ContactBookDirectoryDeleteMutation)

  // Return Component.
  return (
    <DeleteCard onClose={onClose} onConfirm={() =>
      MutationContactBookDirectoryDelete({
        'variables': {
          'contactBookDirectoryId': passOn?.contactBookDirectoryId
        }
      }).then(i => {
        // Style Guide.
        toast(i?.data?.ContactBookDirectoryDelete?.message)

        // Report success.
        return onClose?.()
      }).catch(() =>
        // Style Guide.
        toast('Something went wrong please try after some time.'))} isLoading={MutationContactBookDirectoryDeleteResponse.loading} />
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {
  'passOn': PropTypes.object,
  'onClose': PropTypes.func
}


/*
 * REDUX
 */
const _MapStateToProps = __state => ({ 'passOn': __state.PassOn })


/*
 * EXPORT
 */
export default connect(_MapStateToProps)(Index)
